import { TaskStatus } from '@/assets/enums'

/** Order of the one-click status cycle, shared by the task card and the list view. */
export const TASK_STATUS_CYCLE = [
  TaskStatus.TO_DO,
  TaskStatus.RUNNING,
  TaskStatus.DONE,
  TaskStatus.AWAITING
]
